export default __webpack_public_path__ + "static/media/improve-mobility.31a02eff.png";